// extracted by mini-css-extract-plugin
export default {"fields":"UJLIJe","gaps":"gp6v1H","time":"eSrhqG","fieldsWrap":"ZVk8C8","dateParts":"rs1Xam","mobile":"TeNVER"};